import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
    GetDeviceSuccess,
    GetDeviceFailure,
    SsidFailure,
    SsidSuccess,
    PasswordSuccess,
    PasswordFailure,
    RebootFailure,
    RebootSuccess,
    ResetFailure,
    ResetSuccess,
} from './actions';
import { GET_DEVICE, PASSWORD, SSID, REBOOT, RESET } from './actionTypes';
import apiJunction from '../../utils/api';
import { version } from '../../config';

export interface ResponseGenerator {
    config?: any;
    data?: any;
    headers?: any;
    request?: any;
    status?: number;
    statusText?: string;
}

//get device api
function* getDevice(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `/devicesvc/${version}/device/customer/${action.payload.customerId}`,
        });

        if (response && response.data && response.data.data) {
            yield put(
                GetDeviceSuccess({
                    getDevice: response.data,
                }),
            );
        }
    } catch (e) {
        yield put(
            GetDeviceFailure({
                errorGetDevice: e.response && e.response.data,
            }),
        );
    }
}

//post ssid api
function* ssid(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `/devicesvc/${version}/device/ssid/change/${action.payload.customerId}`,
            body: action.payload.body,
        });

        yield put(
            SsidSuccess({
                SuccessSsid: response.data,
            }),
        );
    } catch (e) {
        yield put(
            SsidFailure({
                errorSsid: e.response && e.response.data,
            }),
        );
    }
}
//post password api
function* password(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `/devicesvc/${version}/device/password/change/${action.payload.customerId}`,
            body: action.payload.body,
        });

        yield put(
            PasswordSuccess({
                SuccessPassword: response.data,
            }),
        );
    } catch (e) {
        yield put(
            PasswordFailure({
                errorPassword: e.response && e.response.data,
            }),
        );
    }
}

//post reboot api
function* reboot(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `/devicesvc/${version}/device/reboot/${action.payload.customerId}`,
            // body: action.payload.body,
        });

        yield put(
            RebootSuccess({
                SuccessReboot: response.data,
            }),
        );
    } catch (e) {
        yield put(
            RebootFailure({
                errorReboot: e.response && e.response.data,
            }),
        );
    }
}
function* reset(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `/devicesvc/${version}/device/reset/${action.payload.customerId}`,
            // body: action.payload.body,
        });

        yield put(
            ResetSuccess({
                SuccessReset: response.data,
            }),
        );
    } catch (e) {
        yield put(
            ResetFailure({
                errorReset: e.response && e.response.data,
            }),
        );
    }
}

function* DeviceSaga() {
    yield all([
        takeLatest(GET_DEVICE, getDevice),
        takeLatest(SSID, ssid),
        takeLatest(PASSWORD, password),
        takeLatest(REBOOT, reboot),
        takeLatest(RESET, reset),
    ]);
}
export default DeviceSaga;
